var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"suggestions-popup",style:({
        left: `${_setup.offset.left}px`,
        top: `${_setup.offset.top}px`,
        width: `${_setup.width}px`,
    })},[_c('ul',{ref:"scroller",staticClass:"scroller"},_vm._l((_vm.options),function(option,i){return _c('li',{key:option.recipe_id,staticClass:"item",class:{ focused: i === _vm.focusIndex }},[_c('a',{staticClass:"link",attrs:{"href":"#","data-id":option.recipe_id},on:{"click":_setup.handleClick}},[_vm._v("\n                "+_vm._s(option.title)+"\n            ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }